import { render, staticRenderFns } from "./TableObsequiosAprobar.vue?vue&type=template&id=33dce281"
import script from "./TableObsequiosAprobar.vue?vue&type=script&lang=js"
export * from "./TableObsequiosAprobar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports